import { useState } from 'react';
import { IUser } from 'types';
import useModal from 'hooks/useModal';
import { UserQuery } from 'queries';
import { toast } from 'react-toastify';
import { DEFAULT_ERROR_MESSAGE } from 'data/message';

interface Props {
  user: IUser;
}

function useEdit({ user }: Props) {
  const { handleAlert } = useModal();
  const { mutate } = UserQuery.usePut();
  const [isOpenEdit, setIsOpenEdit] = useState(false);

  const handleSave = (data: IUser) => {
    mutate(
      {
        id: user.id,
        vms: data.vms || '',
        id1365: data.id1365 || '',
        instagram: data.instagram || '',
      },
      {
        onSettled: () => setIsOpenEdit(false),
        onSuccess: () => toast.success('회원 정보가 수정되었습니다.'),
        onError: () => handleAlert(DEFAULT_ERROR_MESSAGE),
      },
    );
  };

  return { isOpenEdit, setIsOpenEdit, handleSave };
}

export default useEdit;
